import { render, staticRenderFns } from "./SidebarEmptyState.vue?vue&type=template&id=1b82def9"
import script from "./SidebarEmptyState.vue?vue&type=script&lang=js"
export * from "./SidebarEmptyState.vue?vue&type=script&lang=js"
import style0 from "./SidebarEmptyState.vue?vue&type=style&index=0&id=1b82def9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports